import { useCallback } from 'react';

function useImageError() {
  return useCallback((e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = '/images/company-placeholder.png';
  }, []);
}

export { useImageError };
